import AlertsAll from 'common/alerts/containers/alert-all-container';
import { clearNavigationalInfo } from 'common/navigation/containers/navigation-actions';
import { getReferenceData } from 'common/reference-data/containers/reference-data-actions';
import getShowOrderEdit from 'common/user/containers/user-selectors';
import { deleteDraftRequest } from 'drafts/containers/draft-actions';
import { savePartnerRequest } from 'order/change-partner/containers/change-partner-actions';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Outlet, Route, Routes } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import { openPlanningAndView } from '../../../common/gantt/containers/gantt-actions';
import useSockets from '../../../sockets/components/useSockets';
import { subscribe, unsubscribe } from '../../../sockets/containers/socket-actions';
import { connectionStates } from '../../../utils/app-configs';
import Details from '../components/details';
import {
  addSubOrderRequest,
  externalRemove,
  getLinkedPlanningsRequest,
  getOrderDetailsRequest,
  getOrderDetailsStatusRequest,
  getOrderDetailsSuccess,
  saveOrderRequest,
} from './details-actions';
import orderDetailsSockets from './details-sockets';

const DetailsWithSidepanel = (props) => {
  const [connectionState] = useSockets(orderDetailsSockets, ['useRealtimeEventsForOrderDetails']);
  const dispatch = useDispatch();
  const { connection, subscriptions } = useSelector(state => state.sockets);
  const { connectionId } = connection;

  useEffect(() => {
    if (
      connectionId &&
      isToggleEnabled('useRealtimeEventsForOrderDetails')
    ) {
      dispatch(subscribe({ entityId: props.id, connectionId }));
    }
    return () => {
      if (isToggleEnabled('useRealtimeEventsForOrderDetails') &&
        connectionId &&
        props.id
      ) {
        dispatch(unsubscribe({ entityId: props.id, connectionId }));
      }
    };
  }, [props.id, connectionId]);

  return <>
    <Details
      {...props}
      useSockets={
        connectionState === connectionStates.Connected &&
        subscriptions.find(s => s === props.id)
      }
    />
    <Routes>
      <Route path={'alerts'} element={<AlertsAll />} />
    </Routes>
    <Outlet />
  </>;
};


const mapStateToProps = (state) => {
  const activeServiceCenter = state.navigation.navigationSelf.serviceCenterId;
  return {
    data: state.order.details.data,
    isLoading: state.order.details.isLoading || state.navigation.loading,
    error: state.order.details.error,
    isSaving: state.order.details.isSaving,
    saveSuccess: state.order.details.saveSuccess,
    removeSuccess: state.order.details.removeSuccess,
    changes: state.order.details.changes,
    notes: state.order.details.notes,
    serviceNoteValue: state.order.details.serviceNoteValue,
    invoiceNoteValue: state.order.details.invoiceNoteValue,
    partners: state.order.details.partners,
    orderPartList: state.order.details.orderPartList,
    subcontracts: state.order.details.subcontracts,
    vendors: state.order.details.vendors,
    partnerTypes: state.referenceData.data[`${activeServiceCenter}_order_partnerTypes`],
    orderStates: state.order.details.orderStates,
    linkedOrders: state.order.details.linkedOrders,
    linkedPlanning: state.order.details.linkedPlanning,
    lock: state.order.details.lock,
    lockingErrorType: state.order.details.lockingErrorType,
    showOrderEdit: getShowOrderEdit(state),
    redirect: state.order.details.redirect,
    isDeletingDraft: state.drafts.isDeletingDraft,
    lockingErrors: state.order.details.lockingErrors,
    operationInfo: state.currentStatus.operationInfo,
    warnings: state.order.details.warnings,
    resetDirtyIndicator: state.order.details.resetDirtyIndicator,
    validationInfo: state.order.details.validationInfo,
    activeParents: state.navigation.navigationParents,
    userStatuses: state.order.details.userStatuses,
    serviceCenterId: state.navigation.navigationSelf.serviceCenterId,
    isLoadingTasklist: state.order.taskLists.isLoading,
    isExternalRemove: state.order.details.isExternalRemove,
    resetFields: state.order.details.resetFields,
    userId: state.user.id,
  };
};

const mapDispatchToProps = {
  getOrderDetailsRequest,
  saveOrderRequest,
  addSubOrderRequest,
  deleteDraftRequest,
  clearNavigationalInfo,
  savePartnerRequest,
  getOrderDetailsSuccess,
  openPlanningAndView,
  getLinkedPlanningsRequest,
  getReferenceData,
  getOrderDetailsStatusRequest,
  externalRemove,
};

DetailsWithSidepanel.propTypes = {
  id: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(DetailsWithSidepanel),
);
